import RestService from '../services/rest';

// GET
async function getQRCodeConfig(qrCodeConfigId) {
  return RestService.getAuthenticated(`QRCodeConfig/detail?qrCodeConfigId=${qrCodeConfigId}`);
}

async function getAllQRCodes(QRCodeConfig) {
  return RestService.getAuthenticated('QRCodeConfig/list/all', QRCodeConfig);
}

async function getQRCodeConfigByCode(qrCodeConfigCode) {
  return RestService.getAuthenticated('qrCodeConfig/detail/getQRCodeConfigByCode', { qrCodeConfigCode });
}

// POST
async function createQRCodeConfig(QRCodeConfig) {
  return RestService.postAuthenticated('QRCodeConfig/create', QRCodeConfig);
}

// PUT
async function updateQRCodeConfig(QRCodeConfig) {
  return RestService.putAuthenticated('QRCodeConfig/update', QRCodeConfig);
}

// DELETE
async function deleteQRCodeConfig(qrCodeConfigId) {
  return RestService.postAuthenticated('QRCodeConfig/delete', { qrCodeConfigId });
}

export default {
  getQRCodeConfig,
  getAllQRCodes,
  createQRCodeConfig,
  updateQRCodeConfig,
  deleteQRCodeConfig,
  getQRCodeConfigByCode,
};
